// @flow
import type { ExpressParams } from '@rover/react-lib/types';

const getUrlParameter = (name: string, expressParams: ?ExpressParams) =>
  decodeURIComponent(
    (new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search) || [
      undefined,
      '',
    ])[1].replace(/\+/g, '%20')
  ) || null;

export default getUrlParameter;



// WEBPACK FOOTER //
// ../utilities/getUrlParameter.client.js